module.exports = __webpack_public_path__ + "static/media/CAKE.5b8e6561.svg";